import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import TableHeader from './TableHeader'
import TableItem from './TableItem'
import { Spinner } from 'controls'
import { NexPaginate } from 'components/Paginate'
import { utils } from 'services'
import style, { tableItem } from './style'

class TableToCard extends PureComponent {
  constructor(props) {
    super(props)

    this.guid = utils.getGuid()
  }

  render() {
    const {
      fields,
      items,
      currentPage,
      loading,
      onPageChange,
      onItemClick,
      showPaginate,
      scrollTable,
      showExtraContent,
      showHeaderCard,
      pageCount
    } = this.props

    return (
      <div
        className={classnames('wrapper-table-container', {
          scroll: scrollTable
        })}
      >
        <TableHeader
          fields={fields}
          tableGuid={this.guid}
          scrollTable={scrollTable}
        />
        <div className="table-body">
          {loading && (
            <div className="loading-overlay">
              <Spinner size={40} />
            </div>
          )}
          {items && items.length > 0 ? (
            items.map((item, index) => (
              <TableItem
                onClick={onItemClick}
                key={index}
                item={item}
                fields={fields}
                scrollTable={scrollTable}
                showHeaderCard={showHeaderCard}
                showExtraContent={showExtraContent}
              />
            ))
          ) : (
            <div className="table-item-container center">Sin datos ...</div>
          )}
        </div>
        {showPaginate && (
          <NexPaginate
            selected={currentPage}
            onPageChange={onPageChange}
            pageCount={pageCount}
          />
        )}
        <style jsx>{tableItem}</style>
        <style jsx>{style}</style>
      </div>
    )
  }
}

export default TableToCard

TableToCard.propTypes = {
  onItemClick: PropTypes.func,
  onPageChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  fields: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired
}

TableToCard.defaultProps = {
  onItemClick: () => {},
  onPageChange: () => {},
  loading: false,
  showPaginate: false,
  scrollTable: false,
  showHeaderCard: true,
  showExtraContent: true
}
